import { render, staticRenderFns } from "./giftList.vue?vue&type=template&id=6de5beb6&scoped=true&"
import script from "./giftList.vue?vue&type=script&lang=js&"
export * from "./giftList.vue?vue&type=script&lang=js&"
import style0 from "./giftList.vue?vue&type=style&index=0&id=6de5beb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de5beb6",
  null
  
)

export default component.exports